import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  teamMembers: [],
};

const getters = {
  getTeamMembers: (state) => state.teamMembers,
  getTeamMemberById: (state) => (id) =>
    state.teamMembers.find((x) => x.id == id),
};

const actions = {
  async fetchTeamMembers({ commit }) {
    try {
      const resp = await api.get("/team");
      if (resp.status == 200) {
        const teamMembers = resp.data.data;
        console.log("teamMembers", teamMembers);
        commit("setTeamMembers", teamMembers);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateTeamMember({ commit }, teamMember) {
    console.log("xxx:", teamMember);
    try {
      const formData = new FormData();
      if (teamMember.photo != null) {
        formData.append("photo", teamMember.photo);
      }
      if (teamMember.resume_link != null) {
        formData.append("resume_link", teamMember.resume_link);
      }

      formData.append("name", teamMember.name);
      formData.append("job", teamMember.job);
      formData.append("_method", "patch");
      formData.append("_method", "patch");
      const id = teamMember.id;

      const resp = await api.post(`/team/${id}`, formData);
      if (resp.status == 200) {
        const teamMember = resp.data.data;
        console.log("updated:", teamMember);
        commit("updateTeamMember", teamMember);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addTeamMember({ commit }, teamMember) {
    try {
      const formData = new FormData();
      if (teamMember.photo != null) {
        formData.append("photo", teamMember.photo);
      }
      if (teamMember.resume_link) {
        formData.append("resume_link", teamMember.resume_link);
      }

      formData.append("name", teamMember.name);
      formData.append("job", teamMember.job);
      const resp = await api.post(`/team`, formData);

      if (resp.status == 201) {
        const teamMember = resp.data.data;

        commit("addTeamMember", teamMember);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteTeamMember({ commit }, id) {
    try {
      const resp = await api.delete(`/team/${id}`);

      if (resp.status == 203) {
        commit("deleteTeamMember", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setTeamMembers(state, teamMembers) {
    state.teamMembers = teamMembers;
  },
  updateTeamMember(state, teamMember) {
    const id = teamMember.id;
    const index = state.teamMembers.findIndex(
      (teamMember) => teamMember.id == id
    );
    if (index !== -1) {
      state.teamMembers[index] = teamMember;
    }
  },
  addTeamMember(state, teamMember) {
    state.teamMembers.unshift(teamMember);
  },

  deleteTeamMember(state, id) {
    const index = state.teamMembers.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.teamMembers.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
